import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { BadgesLevels, Status } from 'components/misc'
import { Data, Table } from 'components/layout/Table'
import { awardsOverview as awardsOverview } from 'constants/layout'
import config from 'config'
import get from 'lodash/get'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'
import { FormattedDate } from '../../../intl'
import { getGridLabels } from '../../../../helpers/labelHelper'


export default class AwardsOverviewTable extends PureComponent {
  static propTypes = {
    permissions: PropTypes.object.isRequired,
    organizationHierarchyId: PropTypes.number,
    setAwardsOverviewParams: PropTypes.func,
    exportParticipants: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func,
    initialize: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    setFilter: PropTypes.func.isRequired,
  }
  static defaultProps = {
    permissions: {}
  }

  render() {
    const {
      permissions,
      setAwardsOverviewParams,
      setCommonLimit,
      awards,
      configuration,
      activeOrganization
    } = this.props

    let loading = get(awards, 'overview.loading')
    let list = get(awards, 'overview.list')
    let offset = get(awards, 'overview.offset')
    let limit = get(awards, 'overview.limit')
    let pages = get(awards, 'overview.pages')
    let sort = get(awards, 'overview.sort')
    let count = get(awards, 'overview.count')


    const isLabelsEnabled = get(configuration, `valuesByOrganizationId[${activeOrganization.id}][${CONFIGURATION_KEYS.enableLabels.id}].booleanValue`)

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          count={count}
          sort={sort}
          ths={awardsOverview.tableHeaders({ isLabelsEnabled })}
          setParams={setAwardsOverviewParams}
          permissions={permissions}
        >

          <Data>
            {list.map(
              ({
                 id,
                 state,
                 level,
                 registrationDate,
                 participant,
                 awardLeader
               }) => {
                const pid = get(participant, 'id')
                const globalId = get(participant, 'globalId')
                const firstName = get(participant, 'firstName')
                const lastName = get(participant, 'lastName')
                const personStateValue = get(participant, 'state.type')
                const personStateText = get(participant, 'state.value')
                const participantLabelList = get(participant, 'labelList')
                const currentAwardLeaderId = get(awardLeader, 'id')
                const currentAwardLeaderName = get(awardLeader, 'person.firstName') + ' ' + get(awardLeader, 'person.lastName')
                const awardStateValue = get(state, 'type')
                const awardStateText = get(state, 'value')
                const awardLevel = {'value' : get(level, 'type')}

                return (
                  <tr key={id}>
                    <td>
                      <Link
                        to={{ pathname: `${config.publicPath}/participants/${pid}/detail` }}
                      >
                        {globalId}
                      </Link>
                    </td>
                    <td>{firstName}</td>
                    <td>{lastName}</td>
                    <td>
                      <FormattedDate value={registrationDate} />
                    </td>
                    <td>
                      {level
                        ? <BadgesLevels
                          participantId={pid}
                          levels={[
                            {
                              awardLevel: awardLevel
                            }
                          ]}
                          single
                        />
                        : '---'}
                    </td>
                    <td>
                      <Status state={{ value: personStateValue, translationText: personStateText }} />
                      <br />
                      <small>
                        {awardStateValue && awardStateText}
                      </small>
                    </td>
                    <td>
                      <Link to={`${config.publicPath}/leaders/${currentAwardLeaderId}/detail`}>
                        {currentAwardLeaderName}
                      </Link>
                    </td>
                    {isLabelsEnabled && <td>
                      {participantLabelList && getGridLabels(participantLabelList, () => {}, true)}
                    </td> }
                  </tr>
                )
              }
            )}
          </Data>
        </Table>
      </div>
    )
  }
}
